<template>
  <!-- <nav01 title="客服"></nav01> -->
  <div class="chat-detail">
    <iframe :src="state.kefuUrl" frameborder="0"></iframe>
  </div>
</template>
<script setup>
import { reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getUserInfo } from "../../api/user";
import { getQueryString } from "../../utils/location";
// import touxiang from "@/assets/touxiang_reset.png";

const defaultAvatar = require("../../assets/touxiang_reset.png");

const route = useRoute();
const state = reactive({
  kefuUrl: "",
  gid: "",
  uid: "",
  user_info: {},
  deviceType: false,
});

onMounted(() => {
  state.gid = route.query.gid ? getQueryString("gid") : "";
  state.uid = route.query.uid ? getQueryString("uid") : "";
  getInfo();
});

const getInfo = () => {
  getUserInfo({
    uid: getQueryString("uid"),
    gid: getQueryString("gid"),
  }).then((res) => {
    // console.log("获取用户信息", res);
    if (res.data.code == 1) {
      state.user_info = res.data.data;
    } else {
      state.user_info.avatar =
        "https://oss.zhiquyx.com/data/upload/c7f2391476fd786a07eb4c76913bbf89.JPG";
    }
    configUsr();
  });
};

const configUsr = () => {
  // console.log("配置用户信息", state.user_info);
  ysf("config", {
    uid: state.uid,
    name: state.user_info.user_nicename,
    mobile: state.user_info.mobile,
    robotShuntSwitch: 1, // 机器人优先开关
    // robotId: "4494105", // 机器人ID
    data: JSON.stringify([
      { key: "real_name", value: state.user_info.user_nicename },
      { key: "mobile_phone", hidden: false, value: state.user_info.mobile },
      {
        index: 0,
        key: "account",
        label: "账号",
        value: state.user_info.username,
      },
      {
        index: 1,
        key: "mobile_phone",
        label: "手机号",
        value: state.user_info.mobile,
      },
      {
        index: 2,
        key: "reg_date",
        label: "注册日期",
        value: state.user_info.create_time,
      },
      {
        index: 3,
        key: "last_login",
        label: "上次登录时间",
        value: state.user_info.last_login_time,
      },
      {
        index: 4,
        key: "avatar",
        label: "头像",
        value: state.user_info.avatar,
      },
      {
        index: 5,
        key: "now_gameLogin",
        label: "当前登录游戏",
        value: state.user_info.gamename,
      },
      {
        index: 6,
        key: "game_recharge",
        label: "游戏充值金额",
        value: state.user_info.money,
      },
    ]),
    groupid: "485047022", // 客服组id
    robotShuntSwitch: 1, // 机器人优先开关
    success: function() {
      // 成功回调
      // console.log("上报客户信息成功---", state.uid);
      state.kefuUrl = ysf("url", {
        templateId: "6672783",
      });
    },
    error: function() {
      // 错误回调
      console.log("上报客户信息失败");
    },
  });
};
</script>
<style scoped>
.chat-detail {
  /* padding-top: calc(70px + constant(safe-area-inset-top));
  padding-top: calc(70px + env(safe-area-inset-top)); */
  height: 100vh;
  width: 100vw;
}
iframe {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
</style>
